export default function NoiseOverlay() {
    return <div className="noise-bg" aria-hidden="true" />;
}
